import { render, staticRenderFns } from "./SpecimensToWeb.vue?vue&type=template&id=2a62eefd"
import script from "./SpecimensToWeb.vue?vue&type=script&lang=js"
export * from "./SpecimensToWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports